import { useFormik } from 'formik'
import React, { useEffect, useRef, useState } from 'react'
import Container from '../../base/Container'
import { CiLocationArrow1 } from 'react-icons/ci'
import { Update, GetById, CheckNewDoctorId, UpdateDoctorId } from '../../../configurations/crud/applicationUserCrud'
import { MdErrorOutline } from 'react-icons/md'
import { IoCheckmarkDoneCircleOutline, IoSearchOutline } from 'react-icons/io5'
import { useToast } from '../../controls/Toast/ToastService'
import { EBoolBg, GetEBool, GetEBoolName } from '../../../configurations/enums/EBool'
import LoadingContainer from '../../controls/LoadingContainer'
import Card from '../../controls/Card'
import { GetEGenderName } from '../../../configurations/enums/EGender'
import StatusContainer from '../../controls/StatusContainer'
import { EApplicationUserStatusBg, GetEApplicationUserStatusName } from '../../../configurations/enums/EApplicationUserStatus'
import { BASE_URL, DOCTOR_URL, FEMALE_DR_AVATAR, IsMobileEnv, MALE_DR_AVATAR } from '../../../configurations/initUrls'
import { UploadDP } from './Settings/UploadDP'
import UpdateUser from './UpdateUser'
import { getLoginInfo } from '../../../configurations/auth/getLoginInfo'
import { UploadHeaders } from './Settings/UploadHeaders'
import Input from '../../controls/Input'
import { FaUserMd } from "react-icons/fa";
import { ProfilePrint } from './Prints/ProfilePrint'
import { PrintStarterDash } from './Prints/PrintStaterDash'
import { UploadFooters } from './Settings/UploadFooters'
import useGlobalLoader from '../../../configurations/useGlobalLoader'

export default function Profile() {
    const { start, end } = useGlobalLoader()
    const [profileData, setProfileData] = useState()
    const [isOpenEdit, setIsOpenEdit] = useState(false)
    const [lodingCrud, setLodingCrud] = useState(false)
    const toast = useToast()
    const loginInfo = getLoginInfo()
    const [isEditing, setIsEditing] = useState(false);
    const [newId, setnewId] = useState()
    const [loading, setLoading] = useState(false)
    const [status, setStatus] = useState(0)

    const [editData, setEditData] = useState({
        userId: loginInfo.id,
        fullName: "",
        degree: "",
        specialisationId: "0",
        experiance: 0,
        gender: 0,
        isOnLeave: 0,
        isSmsActive: 0,
        leaveNote: "",
        cityId: 0,
        address: "",
    })

    const ChangeProfile = (param, setValues) => {
        setLodingCrud(true)
        start()
        Update(param).then(res => {
            let mdata = res.data
            if (mdata.succeeded) {
                setIsOpenEdit(false)
                GetProfile()
                toast.open("Profile has been updated successfully.", <IoCheckmarkDoneCircleOutline />, "success")
            } else {
                toast.open(mdata.message, <MdErrorOutline />, "danger")
            }
            setLodingCrud(false)
            end()
        }).catch(errors => {
            setLodingCrud(false)
            end()
            toast.open("Internet not connected, please connect and refresh", <MdErrorOutline />, "danger", 5000)
        })
    }

    useEffect(() => {
        GetProfile()
    }, [])

    const GetProfile = () => {
        setLodingCrud(true)
        start()
        GetById().then(res => {
            let mdata = res.data
            if (mdata.result.succeeded) {
                setProfileData(mdata.data)
            } else {
                setProfileData()
                toast.open(mdata.result.message, <MdErrorOutline />, "danger")
            }
            setLodingCrud(false)
            end()
        }).catch(errors => {
            setProfileData()
            setLodingCrud(false)
            end()
            toast.open("Internet not connected, please connect and refresh", <MdErrorOutline />, "danger", 5000)
        })
    }

    const CheckDrId = () => {
        setLoading(true)
        start()
        CheckNewDoctorId({
            NewDoctorId: newId
        })
            .then(res => {
                let mdata = res.data
                if (mdata.succeeded) {
                    setStatus(1)
                } else {
                    setStatus(2)
                }
                setLoading(false)
                end()
            })
            .catch(errors => {
                setLoading(false)
                end()
                toast.open("Internet not connected, please connect and refresh", <MdErrorOutline />, "danger", 5000)
            })
    }

    const UpdateDrId = () => {
        setLodingCrud(true)
        start()
        UpdateDoctorId({
            NewDoctorId: newId
        })
            .then(res => {
                let mdata = res.data
                if (mdata.succeeded) {
                    setStatus(0)
                    setIsEditing(false)
                    GetProfile()
                    toast.open(mdata.message, <IoCheckmarkDoneCircleOutline />, "success")
                } else {
                    toast.open(mdata.message, <MdErrorOutline />, "danger")
                }
                setLodingCrud(false)
                end()
            })
            .catch(errors => {
                setLodingCrud(false)
                end()
                toast.open("Internet not connected, please connect and refresh", <MdErrorOutline />, "danger", 5000)
            })
    }

    const printRef = useRef();
    return (
        <Container title={"Profile"} heading={<>Profile <CiLocationArrow1 /></>}>
            {
                profileData ?
                    <>
                        <div class="w-full md:w-3/12 md:mx-2">
                            <Card isBorder={true} borderColor={EApplicationUserStatusBg(profileData.status).replace("bg", "border")} >
                                <div className='flex flex-col justify-center items-center'>
                                    {profileData &&
                                        <UploadDP />
                                    }
                                    <h1 class="text-gray-900 font-bold text-xl leading-8 my-1 flex items-center">Dr. {profileData.fullName}</h1>
                                    <h3 class="text-gray-600 font-lg text-semibold leading-6">{profileData.userName} ({GetEGenderName(profileData.gender)})</h3>
                                    <div class="px-4 py-2">
                                        <StatusContainer
                                            bg={EApplicationUserStatusBg(profileData.status)}
                                            text={GetEApplicationUserStatusName(profileData.status)}
                                        />
                                        <button onClick={() => {
                                            setEditData({
                                                ...profileData,
                                                userId: loginInfo.id
                                            }); setIsOpenEdit(!isOpenEdit)
                                        }} type="button" class="ms-2 bg-sky-500 hover:bg-sky-600 text-white text-xs py-1 px-2 rounded " title='Update Profile'>Edit</button>
                                    </div>
                                </div>
                            </Card>
                            <div class="my-5"></div>

                            {isEditing ? (
                                <Card isBorder={true} title={"Edit Doctor's Id"} borderColor="border-orange-300">
                                    <div>
                                        <div className="text-gray-700">
                                            <div className="flex flex-col gap-2">
                                                <div className="text-xs sm:text-sm">
                                                    <a
                                                        href={DOCTOR_URL + profileData.doctorId}
                                                        target="_blank"
                                                        className="text-blue-700 break-all hover:text-blue-800 hover:underline"
                                                    >
                                                        {DOCTOR_URL + profileData.doctorId}
                                                    </a>
                                                </div>
                                                <div className='flex gap-1'>
                                                    <Input
                                                        Icon={<FaUserMd />}
                                                        type="text"
                                                        value={newId}
                                                        onChange={(e) => setnewId(e.target.value)}
                                                        // defaultValue={profileData.doctorId}
                                                        className="border w-full rounded p-2 text-sm"
                                                    />

                                                    <button
                                                        onClick={CheckDrId}
                                                        className="bg-sky-500 text-white px-3 py-1 rounded hover:bg-sky-600"
                                                        disabled={loading}
                                                    >
                                                        {loading ? "..." : "Check"}
                                                    </button>
                                                </div>
                                                {status == 1 ? <span className='text-sm text-green-600'>Available!</span> : status == 0 ? "" : <span className='text-sm text-red-600'>Unavailable!</span>}

                                                <div className="flex gap-2 mt-3">

                                                    <button
                                                        onClick={UpdateDrId}
                                                        disabled={lodingCrud}
                                                        className="px-4 py-2 text-sm font-medium bg-green-500 hover:bg-green-600 text-white rounded"
                                                    >
                                                        {lodingCrud ? "Saving" : "Save"}
                                                    </button>
                                                    <button
                                                        type="button"
                                                        onClick={() => { setIsEditing(false); setStatus(0) }}
                                                        className="px-3 py-1 text-sm font-medium bg-gray-500 hover:bg-gray-600 text-white rounded"
                                                    >
                                                        Cancel
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Card>
                            ) : (
                                <Card isBorder={true} title={"Doctor's Id"} borderColor="border-orange-300">
                                    <div className="text-gray-700">
                                        <div className="flex flex-col gap-2">
                                            <div className="text-xs sm:text-sm">
                                                <a
                                                    href={DOCTOR_URL + profileData.doctorId}
                                                    target="_blank"
                                                    className="text-blue-700 break-all hover:text-blue-800 hover:underline"
                                                >
                                                    {DOCTOR_URL + profileData.doctorId}
                                                </a>
                                            </div>

                                            <div className="flex gap-2 mt-3">
                                                <button
                                                    type="button"
                                                    className="w-full px-2 py-1 text-sm font-medium bg-sky-500 hover:bg-sky-600 text-white rounded"
                                                    onClick={() => { setIsEditing(true); setnewId(profileData.doctorId) }}
                                                >
                                                    Edit URL
                                                </button>
                                                {profileData && !IsMobileEnv &&
                                                    <>
                                                        <PrintStarterDash text="Print Qr" printRef={printRef} />
                                                        <div style={{ display: "none" }}>
                                                            <ProfilePrint data={profileData} ref={printRef} />
                                                        </div>
                                                    </>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </Card>
                            )}
                        </div>

                        <div class="my-4"></div>
                        <div class="flex flex-col w-full md:w-9/12 md:mx-2 ">
                            <div class="w-full">
                                <Card isBorder={true} title={"Doctor's Status"} >
                                    <div class="text-gray-700">
                                        <div class="grid md:grid-cols-2 text-sm">

                                            <div class="grid grid-cols-2">
                                                <div class="px-4 py-2 font-semibold">Is On Leave</div>
                                                <div class="px-4 py-2"><StatusContainer bg={EBoolBg(profileData.isOnLeave)} text={GetEBoolName(profileData.isOnLeave)} /></div>
                                            </div>
                                            <div class="grid grid-cols-2">
                                                <div class="px-4 py-2 font-semibold">Leave Note</div>
                                                <div class="px-4 py-2">{profileData.leaveNote ? profileData.leaveNote : "N/A"}</div>
                                            </div>
                                            <div class="grid grid-cols-2">
                                                <div class="px-4 py-2 font-semibold">Is Sms Active</div>
                                                <div class="px-4 py-2"><StatusContainer bg={EBoolBg(profileData.isSmsActive)} text={GetEBoolName(profileData.isSmsActive)} /></div>
                                            </div>
                                        </div>
                                    </div>
                                </Card>
                            </div>
                            {profileData.roleName === "Doctor" &&
                                <>
                                    <div class="my-2"></div>
                                    <div class="w-full">
                                        <Card isBorder={true} title={"Qualification & Experience"} borderColor='border-sky-300'>
                                            <div class="text-gray-700">
                                                <div class="grid md:grid-cols-2 text-sm">
                                                    <div class="grid grid-cols-2">
                                                        <div class="px-4 py-2 font-semibold">Specialisation Id</div>
                                                        <div class="px-4 py-2">{profileData.specialisation.name} ({profileData.specialisation.shortName})</div>
                                                    </div>
                                                    <div class="grid grid-cols-2"><div class="px-4 py-2 font-semibold">Experience</div>
                                                        <div class="px-4 py-2">{profileData.experiance} years</div>
                                                    </div>
                                                    <div class="grid grid-cols-2">
                                                        <div class="px-4 py-2 font-semibold">Degree</div>
                                                        <div class="px-4 py-2">{profileData.degree}</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </Card>
                                    </div>

                                    <div class="my-2"></div>
                                    <div class="w-full">
                                        <Card isBorder={true} title={"Address"}>
                                            <div class="text-gray-700">
                                                <div class="grid md:grid-cols-2 text-sm">
                                                    <div class="grid grid-cols-2">
                                                        <div class="px-4 py-2 font-semibold">Address</div>
                                                        <div class="px-4 py-2">{profileData.address}</div>
                                                    </div>
                                                    <div class="grid grid-cols-2">
                                                        <div class="px-4 py-2 font-semibold">City</div>
                                                        <div class="px-4 py-2">{profileData.city.name}</div>
                                                    </div>
                                                    <div class="grid grid-cols-2">
                                                        <div class="px-4 py-2 font-semibold">State</div>
                                                        <div class="px-4 py-2">{profileData.city.state.name} ({profileData.city.state.shortName})</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </Card>
                                    </div>

                                    <div class="my-2"></div>
                                    <div class="w-full">
                                        <Card isBorder={true} title={"Header Image (5:1 | 1000*200 | This Image resolution will be perfect)"}>
                                            {profileData &&
                                                <div className='w-full'>
                                                    <UploadHeaders />
                                                </div>
                                            }
                                        </Card>
                                    </div>

                                    <div class="my-2"></div>
                                    <div class="w-full">
                                        <Card isBorder={true} title={"Footer Image (5:1 | 1000*200 | This Image resolution will be perfect)"}>
                                            {profileData &&
                                                <div className='w-full'>
                                                    <UploadFooters />
                                                </div>
                                            }
                                        </Card>
                                    </div>
                                </>
                            }
                        </div>
                        <UpdateUser isOpen={isOpenEdit} setIsOpen={setIsOpenEdit} editData={editData} EditProfileData={ChangeProfile} loding={lodingCrud} />
                    </>
                    :
                    <div class="w-full">
                        <LoadingContainer text={"Getting doctor's profile"} />
                    </div>
            }
        </Container>
    )
}
